import { render, staticRenderFns } from "./SuppliersAccount.vue?vue&type=template&id=ee03e938"
import script from "./SuppliersAccount.vue?vue&type=script&lang=js"
export * from "./SuppliersAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports